import { render, staticRenderFns } from "./PageTop.vue?vue&type=template&id=43ed7c4e&scoped=true"
import script from "./PageTop.vue?vue&type=script&lang=js"
export * from "./PageTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ed7c4e",
  null
  
)

export default component.exports